'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const Route = require('common/route');
const TagAction = require('system/domain/action/tag');
const DiagramRepository = require('system/domain/repository/diagram');
const ElementRepository = require('system/domain/repository/element');
const TagRepository = require('system/domain/repository/tag');
const TypeaheadView = require('common/ui/view/typeahead');
const Template = require('system/ui/template/search.hbs');
const TagItemTemplate = require('system/ui/template/detail/searchbox-tag-item.hbs');
const OwnerDropdownItemTemplate = require('system/ui/template/detail/searchbox-owner-item.hbs');
const SearchboxItemTemplate = require('system/ui/template/detail/searchbox-dropdown-item.hbs');

const SearchView = Mn.View.extend({
    template: Template,
    ui: {
        searchInput: 'input'
    },

    initialize: function() {
        this._context = this.getOption('context');
        this._members = this.getOption('members');
        this._diagram = DiagramRepository.getDiagrams({
            context: this._context
        }).get(this._context.diagramId);
    },

    query: function(query) {
        this.ui.searchInput.val(query);
        this.ui.searchInput.trigger('keyup');
        this.ui.searchInput.focus();
    },

    onRender: function() {
        const diagram = this._diagram;
        const context = this._context;
        const members = this._members;

        const getModels = function() {
            return _.flatten([
                ElementRepository.getNodes({
                    context: context
                })
                    .chain()
                    .filter(function(m) {
                        return !m.get('deleted') &&
                            diagram.hasElement(m);})
                    .value(),
                ElementRepository.getLinks({
                    context: context
                })
                    .chain()
                    .filter(function(m) {
                        return !m.get('deleted') &&
                            diagram.hasElement(m);})
                    .value(),
                TagRepository.getTags({
                    context: context
                })
                    .chain()
                    .filter(function(m) {
                        return !m.get('deleted')})
                    .value(),
                members
                    .chain()
                    .filter(function(m) {
                        return !m.get('deleted')})
                    .value()
            ]);
        };

        const tagFilter = function(query) {
            const words = query.match(/tag:"?([^("]+)"?(:?\(#([0-9a-f]+)\))?/);
            if(!words) {
                return null;
            }
            const tagName = words[1];
            const tagId = words[3];
            let tagIds = [];
            if(!tagId) {
                tagIds = _.chain(TagRepository.findTags({
                    context: context,
                    query: tagName
                }))
                    .map(function(tag) {
                        return tag.id;
                    })
                    .value();
            } else {
                tagIds = _.chain(TagRepository.getTags({
                    context: context
                })
                    .filter(function(tag) {
                        return tag.id.startsWith(tagId);
                    }))
                    .map(function(tag) {
                        return tag.id;
                    })
                    .value();
            }
            return function(model) {
                if(model.kind == 'node') {
                    return _.intersection(
                            model.get('tags'), tagIds).length > 0;
                } else {
                    return false;
                }
            };
        };

        const ownerFilter = function(query) {
            const words = query.match(
                /owner:"?([^"(]+)"?(:?\(#([0-9a-f]+)\))?/);
            if(!words) {
                return null;
            }
            const userName = words[1];
            const userId = words[3];
            let userIds = [];
            if(!userId) {
                userIds = _.chain(members.findByQuery({
                    context: context,
                    query: userName
                }))
                    .map(function(member) {
                        return member.getUserID().toString();
                    })
                    .value();
            } else {
                userIds = members
                    .chain()
                    .filter(function(member) {
                        return member.getUserID().toString()
                            .startsWith(userId);
                    })
                    .map(function(member) {
                        return member.getUserID().toString();
                    })
                    .value();
            }
            return function(model) {
                if(model.kind == 'node') {
                    return _.intersection(
                            model.get('owners'), userIds).length > 0;
                } else {
                    return false;
                }
            };
        };

        const queryFilter = function(query) {
            query = query.toLowerCase();
            return function(model) {
                if(model.kind == 'member') {
                    return _.some(model.getUser().getName().split(/\s+/),
                        function(nwords) {
                            return nwords.toLowerCase().indexOf(
                                    query) == 0;
                        });
                } else {
                    //issue 1000992: 古い link で name=null のものがある
                    if(!model.get('name')) {
                        return false;
                    }
                    const target = model.get('name').toLowerCase();
                    return target.indexOf(query) > -1;
                }
            };
        };

        const mode = null;

        new TypeaheadView({
            minLength: 1,
            el: this.ui.searchInput,
            find: function(query) {
                if(query == 'tag:') {
                    return TagRepository.getTags({
                        context: context
                    })
                        .chain()
                        .filter(function(m) {
                            return !m.get('deleted')})
                        .map(function(m) {return m.clone()})
                        .value();
                }

                if(query == 'owner:') {
                    return members
                        .chain()
                        .filter(function(m) {
                            return !m.get('deleted')})
                        .map(function(m) {return m.clone()})
                        .value();
                }

                const queries = query.toLowerCase().match(
                    /(?:[^\s"]+|"[^"]*")+/g);
                let models = _.chain(getModels());
                let filter = null;
                _.each(queries, function(query) {
                    if(query.startsWith('tag:')) {
                        filter = tagFilter(query);
                    } else if(query.startsWith('owner:')) {
                        filter = ownerFilter(query);
                    } else {
                        filter = queryFilter(query);
                    }
                    models = models.filter(filter);
                });
                return _.map(models.value(), function(m) {
                    const n = m.clone();
                    n._id = m.id;
                    return n;
                });
            },

            update: _.bind(function(model) {
                if(model.kind == 'node') {
                    ElementRepository.getNodes({
                        context: context
                    }).get(model.id).select();
                    location.hash = Route.urlFor(
                        'diagram:element', {id: model.id});
                }
                if(model.kind == 'link') {
                    ElementRepository.getLinks({
                        context: context
                    }).get(model.id).select();
                    location.hash = Route.urlFor(
                        'diagram:element', {id: model.id});
                }
                if(model.kind == 'tag') {
                    TagAction.toggleTag({
                        context: context,
                        tag: {id: model.id}
                    });
                    if(mode == 'tag') {
                        const name = model.get('name');
                        const id = model.id.substring(0, 6);
                        return `tag:"${name}"(#${id})`;
                    }
                }
                if(model.kind == 'member') {
                    //TODO Member Model が Relational のため _id を使う
                    model.toggle();
                    if(mode == 'owner') {
                        const name = model.get('name');
                        const id = model.get('user').toString().substring(0, 6);
                        return `owner:"${name}"(#${id})`;
                    }
                }
                return '';
            }, this),

            enter: _.bind(function(query) {
                if(query == '') {
                    return;
                }
                this.trigger('enter', query);
                return '';
            }, this),

            itemView: TypeaheadView.DropdownItemView.extend({
                tagName: 'div',
                render: function() {
                    const j = this.model.toJSON();
                    this.$li = $('<li class="list-item"></li>');
                    this.$el.append(this.$li);
                    if(this.model.kind == 'tag') {
                        this.$li.append(TagItemTemplate(j));
                    } else if(this.model.kind == 'member') {
                        this.$li.append(OwnerDropdownItemTemplate(
                            this.model.getUser().toJSON())
                        );
                    } else {
                        this.$li.append(SearchboxItemTemplate(j));
                    }
                    this.$el.addClass(this.model.kind);
                    return this;
                },
                active: function() {
                    this.$li.addClass(this.getOption('activeClass'));
                },

                deactive: function() {
                    this.$li.removeClass(this.getOption('activeClass'));
                }
            })
        });

        return this;
    }
});

module.exports = SearchView;



// WEBPACK FOOTER //
// ./system/ui/view/search.js